import React from 'react';
import {
  Divider as MaterialDivider,
  DividerProps as MaterialDividerProps,
  createStyles,
  makeStyles,
} from '@material-ui/core';

interface DividerProps extends MaterialDividerProps {
  size?: 'none' | 'small' | 'medium' | 'large';
  visibility: boolean
};

const sizes = {
  none: '0rem',
  small: '1rem',
  medium: '2rem',
  large: '2rem',
};

const Divider = ({ size, visibility = true, ...otherProps }: DividerProps) => {
  const marginSize = sizes?.[size] || 0;
  const useStyles = makeStyles(() =>
    createStyles({
      root: {
        margin: `${marginSize} 0 ${marginSize} 0`,
        ...(!visibility && {backgroundColor: 'transparent'}) 
      },
    })
  );

  const classes = useStyles();

  return <MaterialDivider {...otherProps} className={classes.root} />;
};

export default Divider;
export { Divider };
